export const ArrowIcon = () => (
  <SVG size={16}>
    <path d="M3 5L8 10L13 5H3Z" />
  </SVG>
);

export const CalendarIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.995 2V4H7.995V2H5.995V4H3.005V22H20.995V4H17.995V2H15.995ZM16.995 13H11.995V18H16.995V13ZM4.995 20H18.995V9H4.995V20Z"
    />
  </SVG>
);

export const CloseIcon = () => (
  <SVG size={24}>
    <path d="M20 5.4L18.6 4L12 10.6L5.4 4L4 5.4L10.6 12L4 18.6L5.4 20L12 13.4L18.6 20L20 18.6L13.4 12L20 5.4Z" />
  </SVG>
);

export const ChevronIcon = () => (
  <SVG size={16}>
    <path d="M15.2 5.2L13.8 3.8L8.2 9.4L2.6 3.8L1.2 5.2L8.2 12.2L15.2 5.2Z" />
  </SVG>
);

export const DownloadIcon = () => (
  <SVG size={16}>
    <path d="M14 14H2H0V16H2H14H16V14H14Z" />
    <path d="M13 7L11.6 5.6L9 8.2V0H7V8.2L4.4 5.6L3 7L8 12L13 7Z" />
  </SVG>
);

export const EmailIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00488 4H21.9949V20H2.00488V4ZM11.9949 13L19.9949 8V6L11.9949 11L3.99488 6V8L11.9949 13Z"
    />
  </SVG>
);

export const ClearIcon = () => (
  <SVG size={24}>
    <path
      clipRule="evenodd"
      d="M2 12C2 6.47 6.47 2 12 2C17.53 2 22 6.47 22 12C22 17.53 17.53 22 12 22C6.47 22 2 17.53 2 12ZM15.59 17L17 15.59L13.41 12L17 8.41L15.59 7L12 10.59L8.41 7L7 8.41L10.59 12L7 15.59L8.41 17L12 13.41L15.59 17Z"
      fillRule="evenodd"
    />
  </SVG>
);

export const ExternalIcon = () => (
  <SVG size={16}>
    <path d="M8.8996 0V2H12.5996L5.59961 9.00039L6.99961 10.4004L13.9996 3.4V7.1H15.9996V0H8.8996Z" />
    <path d="M12 14H2V4H5V2H0V16H14V11H12V14Z" />
  </SVG>
);

export const LocationIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 9.35C5 5.2865 7.9365 2 12 2C16.0635 2 19 5.2865 19 9.35C19 14.8625 12 22 12 22C12 22 5 14.8625 5 9.35ZM9 9C9 10.656 10.344 12 12 12C13.656 12 15 10.656 15 9C15 7.344 13.656 6 12 6C10.344 6 9 7.344 9 9Z"
    />
  </SVG>
);

export const MenuIcon = () => (
  <SVG size={24}>
    <path d="M22 4H2V6H22V4Z" />
    <path d="M22 18H2V20H22V18Z" />
    <path d="M16 11H2V13H16V11Z" />
  </SVG>
);

export const PhoneIcon = () => (
  <SVG size={24}>
    <path d="M2.99997 3H7.99997L8.99997 8L6.99997 10C8.19997 14 12.1666 16.3333 14 17L16 15L21 16V21C5.79997 21 2.66663 9 2.99997 3Z" />
  </SVG>
);

export const SearchIcon = () => (
  <SVG size={24}>
    <path d="M16.3 14.9C17.3 13.6 18 11.9 18 10C18 5.6 14.4 2 10 2C5.6 2 2 5.6 2 10C2 14.4 5.6 18 10 18C11.8 18 13.5 17.4 14.9 16.3L20.6 22L22 20.6L16.3 14.9ZM10 16C6.7 16 4 13.3 4 10C4 6.7 6.7 4 10 4C13.3 4 16 6.7 16 10C16 11.3 15.6 12.5 14.9 13.5C14.5 14 14 14.5 13.5 14.9C12.5 15.6 11.3 16 10 16Z" />
  </SVG>
);

export const WebsiteIcon = () => (
  <SVG size={24}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 12C2 9.948 3.948 8 6 8H11V6H6C2.688 6 0 8.688 0 12C0 15.312 2.688 18 6 18H11V16H6C3.948 16 2 14.052 2 12ZM7 13H17V11H7V13ZM13 6H18C21.312 6 24 8.688 24 12C24 15.312 21.312 18 18 18H13V16H18C20.052 16 22 14.052 22 12C22 9.948 20.052 8.03 18 8.03H13V6Z"
    />
  </SVG>
);

export const CheckIcon = () => (
  <SVG size={24}>
    <path d="M8.4 19.95L1.5 13.05L4.5 10.2L8.4 14.1L19.5 3L22.5 6L8.4 19.95Z" />
  </SVG>
);

export const BlockQuoteIcon = () => (
  <SVG size={24}>
    <path d="M13.925 19h8.243v-6.957h-3.155c-.254-2.478 1.476-4 4.987-4.304L23.339 5c-6.056.087-9.414 2.391-9.414 8.13V19zM1 19h8.243v-6.957H6.09c-.255-2.478 1.475-4 4.986-4.304L10.414 5C4.358 5.087 1 7.391 1 13.13V19z" />
  </SVG>
);

export const SpinnerIcon = () => (
  <SVG size={24}>
    <path d="M2 12C2 6.47715 6.47715 2 12 2V5C8.13401 5 5 8.13401 5 12H2Z" />
  </SVG>
);

export const LinkedInIcon = () => (
  <SVG size={24}>
    <path d="M20.5714 2H3.42411C2.63839 2 2 2.64732 2 3.44196V20.558C2 21.3527 2.63839 22 3.42411 22H20.5714C21.3571 22 22 21.3527 22 20.558V3.44196C22 2.64732 21.3571 2 20.5714 2ZM8.04464 19.1429H5.08036V9.59821H8.04911V19.1429H8.04464ZM6.5625 8.29464C5.61161 8.29464 4.84375 7.52232 4.84375 6.57589C4.84375 5.62946 5.61161 4.85714 6.5625 4.85714C7.50893 4.85714 8.28125 5.62946 8.28125 6.57589C8.28125 7.52679 7.51339 8.29464 6.5625 8.29464ZM19.1562 19.1429H16.192V14.5C16.192 13.3929 16.1696 11.9688 14.6518 11.9688C13.1071 11.9688 12.8705 13.1741 12.8705 14.4196V19.1429H9.90625V9.59821H12.75V10.9018H12.7902C13.1875 10.1518 14.1563 9.36161 15.5982 9.36161C18.5982 9.36161 19.1562 11.3393 19.1562 13.9107V19.1429Z" />
  </SVG>
);

export const LinkedInSimpleIcon = () => (
  <SVG size={24}>
    <path d="M6.46770601,21.9554566 L2.32962138,21.9554566 L2.32962138,8.6325167 L6.46770601,8.6325167 L6.46770601,21.9554566 Z M4.39643653,6.81514477 C3.07349666,6.81514477 2,5.71937639 2,4.39643653 C2,3.07349666 3.07349666,2 4.39643653,2 C5.71937639,2 6.79287305,3.07349666 6.79287305,4.39643653 C6.79287305,5.71937639 5.71937639,6.81514477 4.39643653,6.81514477 Z M21.9554566,21.9554566 L17.8262806,21.9554566 L17.8262806,15.4699332 C17.8262806,13.9242762 17.7951002,11.9420935 15.674833,11.9420935 C13.5233853,11.9420935 13.1937639,13.6213808 13.1937639,15.3585746 L13.1937639,21.9554566 L9.06013363,21.9554566 L9.06013363,8.6325167 L13.0289532,8.6325167 L13.0289532,10.4498886 L13.0868597,10.4498886 C13.6391982,9.40311804 14.9888641,8.29844098 17.0022272,8.29844098 C21.1893096,8.29844098 21.9599109,11.0556793 21.9599109,14.636971 L21.9599109,21.9554566 L21.9554566,21.9554566 Z"></path>
  </SVG>
);

export const TwitterIcon = () => (
  <SVG size={24}>
    <path d="M22,5.92893401 C21.4331613,6.75804137 20.747889,7.46446409 19.9441624,8.04822335 C19.9526227,8.16666726 19.9568528,8.34433046 19.9568528,8.58121827 C19.9568528,9.68105457 19.7961099,10.7787593 19.4746193,11.8743655 C19.1531287,12.9699716 18.6645549,14.0211456 18.0088832,15.0279188 C17.3532116,16.034692 16.5727626,16.925123 15.6675127,17.6992386 C14.7622628,18.4733541 13.6709032,19.0909452 12.393401,19.5520305 C11.1158989,20.0131157 9.74958426,20.2436548 8.29441624,20.2436548 C6.00168058,20.2436548 3.90356282,19.6302938 2,18.4035533 C2.29610977,18.4373944 2.62605571,18.4543147 2.98984772,18.4543147 C4.89341053,18.4543147 6.58967107,17.8705642 8.0786802,16.7030457 C7.19035089,16.6861251 6.39509657,16.4132852 5.6928934,15.8845178 C4.99069023,15.3557503 4.50846155,14.6810532 4.24619289,13.8604061 C4.52538211,13.9027075 4.78341675,13.9238579 5.02030457,13.9238579 C5.38409657,13.9238579 5.74365305,13.877327 6.09898477,13.784264 C5.1514335,13.5896775 4.36675438,13.118024 3.74492386,12.3692893 C3.12309334,11.6205546 2.81218274,10.751274 2.81218274,9.76142132 L2.81218274,9.7106599 C3.38748173,10.0321505 4.00507284,10.2055836 4.66497462,10.2309645 C4.10659619,9.85871218 3.6624382,9.37225343 3.33248731,8.7715736 C3.00253642,8.17089378 2.83756345,7.51946206 2.83756345,6.81725888 C2.83756345,6.07275431 3.0236868,5.3832519 3.39593909,4.74873096 C4.41963287,6.00931256 5.66539029,7.01818572 7.13324873,7.77538071 C8.60110717,8.5325757 10.1725805,8.95346827 11.8477157,9.03807107 C11.7800335,8.71658046 11.7461929,8.40355482 11.7461929,8.09898477 C11.7461929,6.96530736 12.1459351,5.99873496 12.9454315,5.19923858 C13.7449279,4.3997422 14.7115003,4 15.8451777,4 C17.0296168,4 18.0279147,4.43146777 18.8401015,5.29441624 C19.762272,5.11675038 20.6294376,4.78680444 21.4416244,4.30456853 C21.128594,5.27750063 20.5279232,6.03045419 19.6395939,6.56345178 C20.4263999,6.47884898 21.213194,6.26734518 22,5.92893401 Z"></path>
  </SVG>
);

export const FacebookIcon = () => (
  <SVG size={24}>
    <path d="M17.3846154,2.14423077 L17.3846154,5.31730769 L15.4975962,5.31730769 C14.8084901,5.31730769 14.3437512,5.46153702 14.1033654,5.75 C13.8629796,6.03846298 13.7427885,6.47115096 13.7427885,7.04807692 L13.7427885,9.31971154 L17.2644231,9.31971154 L16.7956731,12.8774038 L13.7427885,12.8774038 L13.7427885,22 L10.0649038,22 L10.0649038,12.8774038 L7,12.8774038 L7,9.31971154 L10.0649038,9.31971154 L10.0649038,6.69951923 C10.0649038,5.20912716 10.4815663,4.05328936 11.3149038,3.23197115 C12.1482413,2.41065294 13.2580059,2 14.6442308,2 C15.8221213,2 16.7355737,2.04807644 17.3846154,2.14423077 Z"></path>
  </SVG>
);

export const YoutubeIcon = () => (
  <SVG size={24}>
    <path d="M22.5403 6.50346C22.2873 5.51804 21.5418 4.74196 20.5953 4.47858C18.8796 4 12 4 12 4C12 4 5.12044 4 3.40474 4.47858C2.45821 4.742 1.71273 5.51804 1.45971 6.50346C1 8.28958 1 12.0162 1 12.0162C1 12.0162 1 15.7428 1.45971 17.5289C1.71273 18.5143 2.45821 19.258 3.40474 19.5214C5.12044 20 12 20 12 20C12 20 18.8796 20 20.5953 19.5214C21.5418 19.258 22.2873 18.5143 22.5403 17.5289C23 15.7428 23 12.0162 23 12.0162C23 12.0162 23 8.28958 22.5403 6.50346ZM10 15.5V12.3835V9L15.5 12L10 15.5Z" />
  </SVG>
);

export const PlayIcon = () => (
  <SVG size={36}>
    <path d="M10 5v26l20-13L10 5z" />
  </SVG>
);

export const InfoIconCircle = () => (
  <SVG size={12}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 0C2.688 0 0 2.688 0 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zM5 10V5h2v5H5zm0-8v2h2V2H5z"
      fill="#8E93AC"
    />
  </SVG>
);

export const FiltersIcon = () => (
  <SVG size={16}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14.6668 13.3333H1.3335V10.6667H14.6668V13.3333ZM4.00016 11.3333H2.66683V12.6667H4.00016V11.3333ZM1.3335 5.33333V2.66666H14.6668V5.33333H1.3335ZM2.66683 4.66666H4.00016V3.33333H2.66683V4.66666ZM14.6668 9.33333H1.3335V6.66666H14.6668V9.33333ZM4.00016 7.33333H2.66683V8.66666H4.00016V7.33333Z"
    />
  </SVG>
);

export const SVG = ({ children, size }) => (
  <svg
    fill="currentColor"
    viewBox={`0 0 ${size} ${size}`}
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);
